import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { numberFormatterInternational } from 'app/utils/telephonyHelpers';
export function getSimulaneousRingHelpText(validPhoneNumber, isInTrial, phoneNumber) {
    let helpTextPhoneNumber = false;
    if (validPhoneNumber) {
        phoneNumber = `(${numberFormatterInternational({
            phoneNumber,
        })})`;
    }
    else if (isInTrial == true) {
        helpTextPhoneNumber = (_jsx("strong", { children: "You can not activate simultaneous ring when you are in trial." }));
    }
    else {
        helpTextPhoneNumber = (_jsx("strong", { children: "To activate simultaneous ring you need to add a phone number to your profile(see / settings / profile)" }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("p", { children: ["With simultaneous ring you will receive calls in Dixa and on your phone", ' ', phoneNumber, " at the same time."] }), _jsxs("p", { children: [" ", helpTextPhoneNumber, " "] })] }));
}
export function getSimulaneousRingHelpTitle(validPhoneNumber, isInTrial) {
    if (isInTrial === false && validPhoneNumber === true) {
        return 'Simultaneous ring';
    }
    if (isInTrial == true) {
        return 'Simultaneous ring (on trial)';
    }
    return 'Simultaneous ring (phone number needed)';
}
